<template>
  <div>
    <b-row>
      <b-col
        v-if="statisticData[0] && statisticData.length"
        cols="12"
      >
        <statistics
          :data="statisticData"
          :title="$t('dashboard.showPostCountByUser')"
        />
      </b-col>
    </b-row>
    <b-row>
      <b-col
        v-if="userArticlesReportData.length"
        cols="12"
      >
        <echart-bar
          :x-data="userList"
          :y-data="userArticlesReportData"
          :title="$t('dashboard.showPostCountByUser')"
        />
      </b-col>
      <b-col
        v-if="managersReportData.length"
        cols="12"
      >
        <echart-bar
          :x-data="userList"
          :y-data="managersReportData"
          :title="$t('dashboard.showManagersReport')"
        />
      </b-col>
      <b-col
        v-if="articlesCategoriesReportData.length"
        cols="6"
      >
        <echart-bar-horizontal
          :x-data="articlesCategoriesReportData"
          :y-data="categoryTitles"
          :title="$t('dashboard.showPostCountByCategory')"
        />
      </b-col>
      <b-col
        v-if="totalArticles && totalVideos && totalQuestions"
        cols="6"
      >
        <echart-doughnut
          :data="contentTypeReport"
          :total="totalContent"
          :title="$t('dashboard.showPostByType')"
        />
      </b-col>
    </b-row>
    <section id="dashboard">
      <img
        class="corner-image"
        src="@/assets/images/pages/dashboard-corner-image.png"
        alt=""
      >
    </section>
  </div>
</template>

<script>
import EchartBar from '@/components/EChart/EchartBar.vue'
import EchartBarHorizontal from '@/components/EChart/EchartBarHorizontal.vue'
import EchartDoughnut from '@/components/EChart/EchartDoughnut.vue'
import Statistics from '@/components/Statistics/Statistics.vue'
import useDashboard from '@/views/pages/dashboard/useDashboard'
import { BRow, BCol } from 'bootstrap-vue'
import { canView } from '@/libs/acl/routeProtection'

export default {
  components: {
    BCol,
    BRow,
    EchartBar,
    EchartBarHorizontal,
    EchartDoughnut,
    Statistics,
  },
  setup() {
    const {
      articlesCategoriesReportData,
      categoryTitles,
      fetchCategories,
      fetchCategoriesReport,
      fetchManagersReport,
      fetchUserCategoriesReport,
      getAllStatistic,
      managersReportData,
      totalArticles,
      totalComments,
      totalFaq,
      totalManagers,
      totalQuestions,
      totalServices,
      totalSpecialists,
      totalSubscriptions,
      totalSuggestions,
      totalTestimonials,
      totalUsers,
      totalVideos,
      userArticlesReportData,
      userList,
    } = useDashboard()

    return {
      articlesCategoriesReportData,
      categoryTitles,
      fetchCategories,
      fetchCategoriesReport,
      fetchManagersReport,
      fetchUserCategoriesReport,
      getAllStatistic,
      managersReportData,
      totalArticles,
      totalComments,
      totalFaq,
      totalManagers,
      totalQuestions,
      totalServices,
      totalSpecialists,
      totalSubscriptions,
      totalSuggestions,
      totalTestimonials,
      totalUsers,
      totalVideos,
      userArticlesReportData,
      userList,
    }
  },
  computed: {
    statisticData() {
      return [this.totalUsers,
        this.totalArticles,
        this.totalComments,
        this.totalFaq,
        this.totalManagers,
        this.totalQuestions,
        this.totalServices,
        this.totalSpecialists,
        this.totalSubscriptions,
        this.totalSuggestions,
        this.totalTestimonials,
        this.totalVideos,
      ]
    },
    contentTypeReport() {
      return [
        { value: this.totalArticles ? this.totalArticles.title : 0, name: this.$t('general.article') },
        { value: this.totalVideos ? this.totalVideos.title : 0, name: this.$t('general.video') },
        { value: this.totalQuestions ? this.totalQuestions.title : 0, name: this.$t('general.question') },
      ]
    },
    totalContent() {
      let total = 0
      total += this.totalArticles ? parseInt(this.totalArticles.title, 10) : 0
      total += this.totalVideos ? parseInt(this.totalVideos.title, 10) : 0
      total += this.totalQuestions ? parseInt(this.totalQuestions.title, 10) : 0
      return total
    },
  },
  created() {
    if (canView('manage', 'all')) {
      this.fetchCategoriesReport('fa')
      this.fetchUserCategoriesReport()
      this.fetchManagersReport()
      this.getAllStatistic()
    }
  },
}
</script>

<style lang="scss">
.corner-image {
  position: absolute;
  bottom: 0;
  z-index: -1;
  height: 280px;
  bottom: 43px;
  right: 24px;
}
</style>
